import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=e3caa2fc&"
import script from "./Research.vue?vue&type=script&lang=js&"
export * from "./Research.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_5a7zypegj5b2h26m45lhzwpe6a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports